/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Checkin_Invalid_Deck_WarnInputs */



/**
* | output |
* | --- |
* | "Your decklist has errors. You can check in, but fix it before playing to avoid a judge warning or penalty." |
*
* @param {Tournament_Checkin_Invalid_Deck_WarnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_checkin_invalid_deck_warn = /** @type {((inputs?: Tournament_Checkin_Invalid_Deck_WarnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Checkin_Invalid_Deck_WarnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre decklist contient des erreurs. Vous pouvez pointer, mais corrigez-la avant de jouer pour éviter un avertissement ou une pénalité du juge.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su decklist tiene errores. Puede hacer check-in, pero corríjala antes de jugar para evitar un aviso o una penalización del juez.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sua decklist tem erros. Você pode fazer check-in, mas corrija-a antes de jogar para evitar uma advertência ou penalidade do juiz.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La tua decklist ha errori. Puoi fare il check-in, ma correggila prima di giocare per evitare un avvertimento o una penalità del giudice.")
	return /** @type {LocalizedString} */ ("Your decklist has errors. You can check in, but fix it before playing to avoid a judge warning or penalty.")
});